import * as React from 'react';
import { Box, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
// import theme from 'theme';
export default function TableGrid({
  rows,
  columns,
  CellonClick,
  updateLevel1Data,
  mobileStyle,
  addNewLevelCode,
}) {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    width: '90%',
    height: '75vh',
    // backgroundColor: '#EDF5E1',
    marginTop: '1rem',
  };

  return (
    <div style={{ ...style, ...mobileStyle }}>
      <Stack alignItems="flex-end" direction='row' spacing={1}>
        <Button
          variant="contained"
          color="primary"
          style={{ width: '60px' }}
          onClick={addNewLevelCode}
        >
          Add
        </Button>
      </Stack>
      <DataGrid
        hideFooter
        headerHeight={20}
        rowHeight={25}
        style={{ width: '100%' }}
        onCellClick={CellonClick}
        onCellDoubleClick={(params, event) => {
          updateLevel1Data(event, params);
        }}
        rows={rows}
        columns={columns}
        pageSize={25}
        disableColumnMenu
      />
    </div>
  );
}
